import ArticleCard from '@/components/base/ArticleCard';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestUpdates() {
  const latest = getLatestArticles(6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              第一时间获取最新收录的同人创作作品
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}